export default {"src":"/_next/static/media/0x176211869ca2b568f2a7d4ee941e073a821ee1ff.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};